export const environment = {
  production: true,
  APIUrl: 'https://thequalidadapi.azurewebsites.net',
  PublicAuthUrl: 'https://thequalidadapi.azurewebsites.net',
  LoginScreen: 'https://thequalidadportal.azurewebsites.net',
  syncfusionLicense:
    'Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH1ecnRSRGhZV0Z2WkU=',
};